import { Button, Checkbox, CloseButton, Drawer, Portal, Text, VStack } from '@chakra-ui/react'

/** [Spec §4.4] Nobody home: a 2-tap confirm. Records NoAnswer + ComeBackLater (+ LeftLiterature). */
export function NobodyHomeSheet({ open, title, names, leftLiterature, onLeftLiteratureChange, onRecord, onClose, isSaving, offerLeftLiterature = true, comeBackLater = true }: {
  open: boolean; title: string; names: string[]; leftLiterature: boolean
  onLeftLiteratureChange: (v: boolean) => void; onRecord: () => void; onClose: () => void; isSaving: boolean
  /** [P6] False when the organizer switched Left literature off. */
  offerLeftLiterature?: boolean
  /** [P6] False when the organizer switched Come back later off. */
  comeBackLater?: boolean
}) {
  return (
    <Drawer.Root open={open} placement="bottom" onOpenChange={(e) => { if (!e.open) onClose() }}>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content borderTopRadius="xl" pb="env(safe-area-inset-bottom, 0px)" shadow="popover">
            <Drawer.CloseTrigger asChild><CloseButton size="sm" minW="44px" minH="44px" /></Drawer.CloseTrigger>
            <Drawer.Header><Drawer.Title>{title}</Drawer.Title></Drawer.Header>
            <Drawer.Body>
              <VStack align="stretch" gap={4} pb={4}>
                <Text color="fg.muted">{names.join(', ')}</Text>
                <Text fontWeight="semibold">{comeBackLater ? 'Not home · come back later ✓' : 'Not home'}</Text>
                {offerLeftLiterature && (
                  <Checkbox.Root checked={leftLiterature} onCheckedChange={(e) => onLeftLiteratureChange(!!e.checked)} minH="44px">
                    <Checkbox.HiddenInput />
                    <Checkbox.Control />
                    <Checkbox.Label>Left literature</Checkbox.Label>
                  </Checkbox.Root>
                )}
                <Button minH="52px" bg="accent" color="accent.fg" disabled={isSaving} onClick={onRecord}>Record</Button>
              </VStack>
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  )
}
